var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"downloaderGalleryLink bg-yellow-photo text-black border-black py-1 px-4 rounded",attrs:{"type":"button"},on:{"click":_vm.handleSave}},[_c('span',{staticClass:"material-icons"},[_vm._v("download")])])
}
var staticRenderFns = []

export { render, staticRenderFns }